import { render, staticRenderFns } from "./PlantPointsInfo.vue?vue&type=template&id=1f3ad772&scoped=true&"
import script from "./PlantPointsInfo.vue?vue&type=script&lang=js&"
export * from "./PlantPointsInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlantPointsInfo.vue?vue&type=style&index=0&id=1f3ad772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ad772",
  null
  
)

export default component.exports